import Vue from 'vue'
import distanceFilter from './filters/distanceFilter'

Vue.filter('distance', distanceFilter)

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('initials', function (value) {
  if (value === undefined) {
    return value
  }
  const split = value.trim().split(' ')
  let intials = ''
  for (let i = 0; i < split.length; i++) {
    intials += split[i][0]
  }
  return intials
})

Vue.filter('monthName', function (value) {
  const months = ["January","February","March","April","May","June","July","August","September","October","November","December"]
  return months[value]
})

Vue.filter('simpleDate', function (value) {
  const date = new Date(value)
  return date.toDateString().split(' ').splice(1).join(' ')
})

Vue.filter('dateTime', function (value) {
  const date = new Date(value)
  return date.toDateString().split(' ').splice(1).join(' ') + ' ' + date.getUTCHours().toString() + ':' + date.getUTCMinutes().toString()
})



// WEBPACK FOOTER //
// ./src/filters.js